
import React from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";

// Full steps array with all routes
const allSteps = [{
  path: "/",
  label: "Property"
}, {
  path: "/new-video/actor",
  label: "Actor"
}, {
  path: "/new-video/script",
  label: "Script"
}, {
  path: "/new-video/checkout",
  label: "Payment"
}];

// Visible steps for the progress bar (all steps)
const visibleSteps = allSteps.slice(0, 3);

const ProgressBar = () => {
  const location = useLocation();
  // Find current step index in the full steps array for functionality
  const currentStepIndex = allSteps.findIndex(step => step.path === location.pathname);
  // Calculate progress percentage based on visible steps only
  const progressPercentage = Math.min(currentStepIndex / (visibleSteps.length - 1) * 100, 100);
  const isMobile = useIsMobile();

  return <div className={`w-full ${isMobile ? 'mb-8' : 'mb-10 px-6'}`}>
      <div className="flex justify-between items-center mb-4 px-[10px]">
        {visibleSteps.map((step, index) => {
        // Determine if this step is active or completed
        const isActive = index <= currentStepIndex;
        const isCompleted = index < currentStepIndex;
        return <div key={step.path} className={`relative flex flex-col items-center ${isActive ? "text-primary" : "text-muted-foreground"}`}>
              <div className={`
                w-8 h-8 rounded-full flex items-center justify-center
                ${isCompleted ? "bg-primary text-white" : isActive ? "border-2 border-primary" : "border-2 border-muted"}
              `}>
                {isCompleted ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 6L9 17l-5-5" />
                  </svg> : <span className="text-xs">{index + 1}</span>}
              </div>
              <span className="absolute top-14 text-xs whitespace-nowrap font-medium">
                {step.label}
              </span>
            </div>;
      })}
      </div>

      <div className="relative w-full h-1 bg-muted rounded-full overflow-hidden mt-4">
        <motion.div className="h-full bg-primary rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${progressPercentage}%`
      }} transition={{
        duration: 0.5,
        ease: "easeInOut"
      }} />
      </div>
    </div>;
};
export default ProgressBar;
